'use strict';

(function ($) {

	$("document").ready(function () {

		$('.underline-js').on('click', function (e) {
			e.preventDefault();
			$('body').toggleClass('underline-js-active');

			if (localStorage.getItem('underline-js-active')) {
				localStorage.removeItem('underline-js-active');
			} else {
				localStorage.setItem('underline-js-active', true);
			}
		});

		function change_links_underline() {
			const get_change_links_underline = localStorage.getItem("underline-js-active");
			if (get_change_links_underline) {
				$("body").toggleClass("underline-js-active");
			}
		}
		change_links_underline();

	});

})(jQuery);
